
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4065","transform":"translate(-981 -295)","opacity":".8"}},[_c('circle',{attrs:{"data-name":"Ellipse 337","cx":"40","cy":"40","r":"40","transform":"translate(981 295)","fill":"#dea404","opacity":".15"}}),_c('g',{attrs:{"data-name":"dollar-circle","fill":"none","stroke":"#b28303","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M1015.453 338.883a3.787 3.787 0 003.7 3.883h4.183a3.314 3.314 0 003.233-3.383 2.916 2.916 0 00-2.2-3.217l-6.716-2.333a2.916 2.916 0 01-2.2-3.217 3.314 3.314 0 013.233-3.383h4.184a3.787 3.787 0 013.7 3.883"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1021 325v20M1037.666 335A16.667 16.667 0 111021 318.333 16.667 16.667 0 011037.666 335z"}})])])])
          )
        }
      }
    